module.exports = __webpack_public_path__ + "static/mountain-video-background-4ab2891eb3d82bb381718bee679d299c.mp4";